export const ADMIN_TABS = [
  "Overview", "HireFlow", "DOCUMENTS", "Approvals", "Verification queue", "Verification services", "Visa requests",
  "Programme reviews", "Study catalogue", "Consultants", "Sponsor imports", "Data sources", "Data quality",
  "Study applications", "Candidates", "Newsroom", "Notifications",
  "WhatsApp Communications", "Message Templates", "Payments", "Users", "Compliance",
  "Audit logs", "System health",
];

export const adminSectionId = (tab) => tab.toLowerCase().replace(/\s+/g, "-");

export const adminTabFromSection = (section) => (
  ADMIN_TABS.find((tab) => adminSectionId(tab) === section) || "Overview"
);

export const adminTabUrl = (tab) => (
  tab === "Overview" ? "/admin" : `/admin?section=${encodeURIComponent(adminSectionId(tab))}`
);

export const OVERVIEW_DESTINATIONS = {
  users: { tab: "Users" },
  employers: { unavailable: "An Administration employer and organisation directory is not available yet." },
  jobs_published: { route: "/jobs" },
  jobs_pending_approval: { tab: "Approvals" },
  applications: { tab: "Candidates" },
  sponsors: { route: "/sponsors" },
  sponsor_imports: { tab: "Sponsor imports" },
  verification_cases: { tab: "Verification queue" },
  bookings: { unavailable: "A tenant-wide Administration bookings view is not available yet." },
  courses: { route: "/study" },
  enrolments: { unavailable: "A tenant-wide Administration enrolments view is not available yet." },
  articles_awaiting_review: { tab: "Newsroom" },
  partners: { unavailable: "A tenant-wide Administration partner directory is not available yet." },
  tenants: { unavailable: "A tenant Administration view is not available yet." },
  audit_events: { tab: "Audit logs" },
  queued_jobs: { tab: "System health" },
};

export const overviewDestination = (key) => {
  const destination = OVERVIEW_DESTINATIONS[key];
  if (!destination) return { unavailable: "No Administration destination is available for this summary." };
  return destination.tab ? { ...destination, route: adminTabUrl(destination.tab) } : destination;
};

export const canAccessVerificationQueue = (roles = []) => (
  roles.some((role) => ["super_admin", "verification_analyst", "verification_supervisor"].includes(role))
);

